import {
  Component,
  Input,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import {
  PrismService,
  GetDataPointsService,
  GoogleAnalyticsService,
} from '@shared/services';

@Component({
  selector: 'dls-code-block',
  templateUrl: './code-block.component.html'
})
export class CodeBlockComponent implements AfterViewInit {

  @Input() codeSnippet: string;
  @Input() language: string;

  codeBlock: string;
  private _codeBlock: string;

  constructor(
    private prismService: PrismService,
    private _getDataPointsService: GetDataPointsService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private hostElement: ElementRef,
    private cd: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private _clipboard: Clipboard,
  ) {
    this.codeSnippet = '';
    this.language = '';
  }

  ngAfterViewInit() {
    // Priority goes to @Input codeSnippet value then the transcluded text
    if (this.codeSnippet.length) {
      this._codeBlock = this.codeSnippet;
      this.codeBlock = this.prismService.highlight(this.codeSnippet, this.language);
    } else if (this.hostElement.nativeElement && this.hostElement.nativeElement.innerText && this.hostElement.nativeElement.innerText.length) {
      this.hostElement.nativeElement.getElementsByClassName('dls-trans-code')[0].innerHTML = this.prismService.highlight(this.hostElement.nativeElement.innerText, this.language);
    }

    // Detect Changes
    this.cd.detectChanges();
  }

  // Returns path for the copy code button
  getCopyCodePath(elem) {
    // Extracts the section element
    this._getDataPointsService.getElement(elem, 'dls-page-section');

    if (!this._getDataPointsService.getMainSectionElement()) { 
      return; 
    }

    const path = [
      this._getDataPointsService.getMainSectionHeading(),
      this._getDataPointsService.getSubSectionHeading(),
      this._getDataPointsService.getExampleViewerTitle(),
      this._getDataPointsService.getActiveCodeTab(),
      'Code copied!',
    ];
    
    return path.join('');
  }

  public copyCode(event): void {

    const path = this.getCopyCodePath(event.currentTarget);

    this._googleAnalyticsService.trackPageEvents('click', path.toUpperCase());

    this._clipboard.copy(this._codeBlock);
    this.openSnackbar();
  }

  private openSnackbar(): void {
    this._snackBar.open('Code copied', null, {
      duration: 3000,
      horizontalPosition: 'start',
      verticalPosition: 'bottom',
    });
  }

}
